import type { MessageDescriptor } from "@lingui/core";
import { msg } from "@lingui/core/macro";

// Over Capacityエラータイプの定数定義
export const OVER_CAPACITY_TYPES = {
  INDEX_WORKER: "index worker",
  INDEX_WORKER_PROJECT: "index worker project",
  SEARCH_ANALYTICS_PROJECT: "search analytics project",
  SEARCH_ANALYTICS_BIGQUERIES: "search analytics bigqueries",
  USER_ANALYTICS_PROJECT: "user analytics project",
  USER_ANALYTICS_BIGQUERIES: "user analytics bigqueries",
  USER_ANALYTICS_VIEW: "user analytics view",
  USER_ANALYTICS_URL_GROUP: "user analytics url group",
  PROPERTY: "property",
  GUEST: "guest",
  USER: "user",
  ORGANIZATION: "organization",
  WORKSPACE: "workspace",
  DASHBOARD: "dashboard",
  QUERY_GROUP: "query group",
  URL_GROUP: "url group",
  VIEW: "view",
} as const;

type OverCapacityType =
  (typeof OVER_CAPACITY_TYPES)[keyof typeof OVER_CAPACITY_TYPES];

// エラーメッセージのマッピング
const ERROR_MESSAGES: Record<OverCapacityType, MessageDescriptor> = {
  "index worker": msg`You've reached the plan limit for index workers. Upgrade your plan to create more index workers.`,
  "index worker project": msg`You've reached the plan limit for index worker projects. Upgrade your plan to create more projects.`,
  "search analytics project": msg`You've reached the plan limit for search analytics projects. Upgrade your plan to create more projects.`,
  "search analytics bigqueries": msg`You've reached the plan limit for search analytics data processing. Upgrade your plan for more capacity.`,
  "user analytics project": msg`You've reached the plan limit for user analytics projects. Upgrade your plan to create more projects.`,
  "user analytics bigqueries": msg`You've reached the plan limit for user analytics data processing. Upgrade your plan for more capacity.`,
  "user analytics view": msg`You've reached the plan limit for user analytics views. Upgrade your plan to create more views.`,
  "user analytics url group": msg`You've reached the plan limit for user analytics URL groups. Upgrade your plan to create more URL groups.`,
  property: msg`You've reached the plan limit for properties. Upgrade your plan to create more properties.`,
  guest: msg`You've reached the plan limit for guest users. Upgrade your plan to invite more guests.`,
  user: msg`You've reached the plan limit for users. Upgrade your plan to add more users.`,
  organization: msg`You've reached the plan limit for organizations. Upgrade your plan to add more organizations.`,
  workspace: msg`You've reached the plan limit for workspaces. Upgrade your plan to create more workspaces.`,
  dashboard: msg`You've reached the plan limit for dashboards. Upgrade your plan to create more dashboards.`,
  "query group": msg`You've reached the plan limit for query groups. Upgrade your plan to create more query groups.`,
  "url group": msg`You've reached the plan limit for URL groups. Upgrade your plan to create more URL groups.`,
  view: msg`You've reached the plan limit for views. Upgrade your plan to create more views.`,
};

// デフォルトメッセージ
const DEFAULT_MESSAGE = msg`You've reached your plan limit. Upgrade your plan to access more features.`;

/**
 * エラータイプに応じたメッセージを取得
 * @param type - エラータイプ
 * @returns Lingui MessageDescriptor
 */
export function getErrorMessageDescriptor(type: string): MessageDescriptor {
  const message = ERROR_MESSAGES[type as OverCapacityType];
  if (message) {
    return message;
  }
  return DEFAULT_MESSAGE;
}
